import * as React from "react"
import { Base } from "./Base"
import { AlliedMarine } from "./AlliedMarine"

type HeaderProps = {
  children?: React.ReactNode
  appendClassNames?: string
  sticky?: boolean
  props?: Record<string, unknown>
}

type HeaderSubcomponent = {
  AlliedMarine: typeof AlliedMarine
}

const Header: React.FC<HeaderProps> & HeaderSubcomponent = (props: HeaderProps): React.JSX.Element => {
  return <Base {...props} />
}

Header.AlliedMarine = AlliedMarine

export {
  Header
}
